(function($) {
	$(document).ready(function(){

		$('.animate-container.first').addClass('anim-init');

		function isScrolledIntoView(elem) {
		    var docViewTop = $(window).scrollTop();
		    var docViewBottom = docViewTop + $(window).height();

		    var elemTop = $(elem).offset().top;
		    var elemBottom = elemTop + $(elem).height();

		    return (((elemTop+300) <= docViewBottom) && (elemTop >= docViewTop));
		}

		$(window).scroll(function () {
		   $('.animate-container').each(function () {
		      if (isScrolledIntoView(this) === true) {
		          $(this).addClass('anim-init');
		      }
		   });
		});

	});
})(jQuery); // Fully reference jQuery after this point.